import FormFields from "@components/common/form/FormFields";
import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { useAnalytics, useError, useLoader, useNotification, usePublishToGMB, useRefetch, } from "@piiqtechnologies/ui-lib";
import { Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import messages from "../../messages.i18n";
import { getPublishToGMBFormFields, PublishToGMBFormInitialValues } from "./PublishToGMBFormConfig";
export const PublishToGMBForm = ({ spaceId, onPublishToGMBSuccess, spaceType, staged }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const [confirmView, setConfrmView] = useState(false);
    const [publishToGMB, publishedToGMB, publishToGMBInProgress, publishToGMBError] = usePublishToGMB();
    useEffect(() => {
        setLoader(publishToGMBInProgress);
        return () => setLoader(false);
    }, [publishToGMBInProgress]);
    useEffect(() => {
        if (publishToGMBError) {
            setError(publishToGMBError === null || publishToGMBError === void 0 ? void 0 : publishToGMBError.message);
        }
    }, [publishToGMBError]);
    useEffect(() => {
        if (publishedToGMB) {
            setNotification(
            // @ts-ignore
            intl.formatMessage(messages.spacePublishToGMBSuccess, {
                link: (link) => React.createElement("a", { href: "https://piiq.atlassian.net/servicedesk/customer/kb/view/2130181" }, link),
            }));
            analytics.track("Publish To GMB");
            setRefetch();
            onPublishToGMBSuccess();
        }
    }, [publishedToGMB]);
    const onPublishToGMB = ({ publishStaged, GMBPlace }) => {
        publishToGMB(Object.assign(Object.assign({}, ((GMBPlace === null || GMBPlace === void 0 ? void 0 : GMBPlace.placeId) && { placeId: GMBPlace.placeId })), { publishStaged,
            spaceId }));
    };
    const fields = getPublishToGMBFormFields();
    const PublishToGMBFormFields = useMemo(() => {
        const [placeField, stagedFields] = fields;
        return [placeField, ...((staged && [stagedFields]) || [])];
    }, [staged]);
    return (React.createElement(Formik, { initialValues: PublishToGMBFormInitialValues, onSubmit: onPublishToGMB },
        React.createElement(Form, null,
            React.createElement(PeekStack, { spacing: 3, textAlign: "left" }, (!confirmView && (React.createElement(React.Fragment, null,
                React.createElement(FormFields, { fields: PublishToGMBFormFields }),
                React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "contained", onClick: (e) => {
                        e.preventDefault();
                        setConfrmView(true);
                    } }, intl.formatMessage(messages.spacePublishToGMBNextButton))))) || (React.createElement(React.Fragment, null,
                React.createElement(PeekTypography, null, intl.formatMessage(messages.spacePublishToGMBFormConfimation)),
                React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "contained", type: "submit" }, intl.formatMessage(messages.spacePublishToGMBButton))))))));
};
export default PublishToGMBForm;
